import agentsTypes from '../types/agents';

const initialStore = {
    agentsList: [],
    noAgents: false,
    searchByMap: false,
    searchAddress: '',
    lastSearchAddress: '',
    searchAddressError: false,
    searchName: '',
    lastSearchName: '',
    searchNameError: false,
    searchError: false,
    currentAgent: {},
    hoveredAgent: 0,
    currentAgency: null,
    workTime: [],
    agentSocials: [],
    agencyWebsiteList: [],
    detailsOpen: false,
    modalOpen: false,
    modalSuccessOpen: false,
    activeMarker: null,
    mapCenter: {
        lat: 31.735174102841363,
        lng: -99.37535083723382,
    },
    mapZoom: 8,
    isLoading: false,
    searchCount: 0,
};

const agentsStore = (state = initialStore, action) => {
    switch (action.type) {
        case agentsTypes.SET_AGENTS_LIST:
            return {
                ...state,
                agentsList: action.array,
            };
        case agentsTypes.SET_NO_AGENTS:
            return {
                ...state,
                noAgents: action.boolean,
            };
        case agentsTypes.SET_SEARCH_BY_MAP:
            return {
                ...state,
                searchByMap: action.boolean,
            };
        case agentsTypes.SET_SEARCH_ADDRESS:
            return {
                ...state,
                searchAddress: action.string,
            };
        case agentsTypes.SET_LAST_SEARCH_ADDRESS:
            return {
                ...state,
                lastSearchAddress: action.string,
            };
        case agentsTypes.SET_SEARCH_ADDRESS_ERROR:
            return {
                ...state,
                searchAddressError: action.boolean,
            };
        case agentsTypes.SET_SEARCH_NAME:
            return {
                ...state,
                searchName: action.string,
            };
        case agentsTypes.SET_LAST_SEARCH_NAME:
            return {
                ...state,
                lastSearchName: action.string,
            };
        case agentsTypes.SET_SEARCH_NAME_ERROR:
            return {
                ...state,
                searchNameError: action.boolean,
            };
        case agentsTypes.SET_SEARCH_ERROR:
            return {
                ...state,
                searchError: action.boolean,
            };
        case agentsTypes.SET_AGENT:
            return {
                ...state,
                currentAgent: action.object,
            };
        case agentsTypes.SET_HOVERED_AGENT:
            return {
                ...state,
                hoveredAgent: action.number,
            };
        case agentsTypes.SET_AGENCY:
            return {
                ...state,
                currentAgency: action.object,
            };
        case agentsTypes.SET_WORK_TIME:
            return {
                ...state,
                workTime: action.array,
            };
        case agentsTypes.SET_AGENT_SOCIALS:
            return {
                ...state,
                agentSocials: action.array,
            };
        case agentsTypes.SET_AGENCY_WEBSITE_LIST:
            return {
                ...state,
                agencyWebsiteList: action.array,
            };
        case agentsTypes.SET_DETAILS_OPEN:
            return {
                ...state,
                detailsOpen: action.boolean,
            };
        case agentsTypes.SET_MODAL_OPEN:
            return {
                ...state,
                modalOpen: action.boolean,
            };
        case agentsTypes.SET_MODAL_SUCCESS_OPEN:
            return {
                ...state,
                modalSuccessOpen: action.boolean,
            };
        case agentsTypes.SET_ACTIVE_MARKER:
            return {
                ...state,
                activeMarker: action.text,
            };
        case agentsTypes.SET_MAP_CENTER:
            return {
                ...state,
                mapCenter: action.object,
            };
        case agentsTypes.SET_MAP_ZOOM:
            return {
                ...state,
                mapZoom: action.number,
            };
        case agentsTypes.SET_LOADING:
            return {
                ...state,
                isLoading: action.boolean,
            };
        case agentsTypes.SET_SEARCH_COUNT:
            return {
                ...state,
                searchCount: action.number,
            };
        default:
            return state;
    }
};

export default agentsStore;
